import { Trans } from '@lingui/macro'
import { useGlobals, useLoyaltySettings } from 'context'
import { domain } from 'helpers'
import { getBookingRoutes } from './bookingRoutes'
import { getCRMRoutes } from './crmRoutes'
import { getLoyaltyRoutes } from './loyaltyRoutes'
import { getNativeAppsRoutes } from './nativeAppsRoutes'
import { getStaffRoutes } from './staffRoutes'
import { getTerminalRoutes } from './terminalRoutes'

export default function Launcher({ location, navigate, environment }) {
  const { global } = useGlobals()
  const { data } = useLoyaltySettings()
  const { annual_active, member_active, season_active } = data || {}
  const { LauncherReact } = window || {}
  const { user, locale } = global || {}
  const {
    firstname,
    middlename,
    lastname,
    roles,
    email,
    organization,
    label,
    clients
  } = user || {}
  const isTerminal = location.pathname.includes('terminal')
  const isBooking = location.pathname.includes('booking')
  const isStaff = location.pathname.includes('staff')
  const isCRM = location.pathname.includes('crm')
  const isLoyalty = location.pathname.includes('loyalty')
  const isApps = location.pathname.includes('apps')
  const name = Boolean(firstname) ? (
    `${firstname}${middlename ? ` ${middlename}` : ''}${
      lastname ? ` ${lastname}` : ''
    }`
  ) : (
    <Trans>My account</Trans>
  )
  const hasMultipleClients = clients !== 0 && clients !== 1
  const menu = isTerminal
    ? getTerminalRoutes(roles, navigate)
    : isBooking
    ? getBookingRoutes(roles, navigate)
    : isStaff
    ? getStaffRoutes(roles, navigate)
    : isCRM
    ? getCRMRoutes(roles, navigate)
    : isLoyalty
    ? getLoyaltyRoutes(roles, navigate, {
        annual_active,
        member_active,
        season_active
      })
    : isApps
    ? getNativeAppsRoutes(roles, navigate)
    : []

  return (
    <LauncherReact
      navigate={navigate}
      location={location}
      environment={environment}
      menu={menu}
      user={{
        name,
        email,
        organization,
        role: label,
        language: locale?.substr(0, 2) || 'da'
      }}
      links={{
        ...(hasMultipleClients ? { switch_client: `${domain}/client` } : {}),
        switch_user: `${domain}/switchuser`,
        change_consent: `${domain}/consent`,
        sign_out: `${domain}/logout`
      }}
    />
  )
}
